import {
	Card,
	CircularProgress,
	IconButton,
	Typography,
} from '@material-ui/core';
import Refresh from '@material-ui/icons/Refresh';
import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DownArrow from '@material-ui/icons/ArrowDropDown';
import UpArrow from '@material-ui/icons/ArrowDropUp';
import { setAppStateAction } from '../../actions/appStateAction';
import { setOptionChainAction } from '../../actions/optionChainAction';
import {  refreshDataAndExpirationsFunc } from '../../Shared';
import SharkIcon from '../icons/shark.png';
import styles from './OptionsBoardStyles';
import { useParams } from 'react-router-dom';

const TickerStats = () => {
	const { appReducer, optionChainReducer } = useSelector((state) => state);
	const dispatch = useDispatch();
	let { ticker } = useParams();

	const { isMobile, holderList, quoteInfo,refreshingQuote } = appReducer;

	const { selectedDate } = optionChainReducer;

	const setAppState = (payload) => dispatch(setAppStateAction(payload));

	let lengthCheck = false;
	if (Object.keys(holderList).length > 0) {
		if (holderList.hieghestCalls.length || holderList.hieghestPuts.length) {
			lengthCheck = true;
		}
	}

	let newDate = moment(new Date()).format('YYYY-MM-DD');
	let checkDate = moment(selectedDate).isSame(newDate, 'day');
	return (
		<Card style={styles.selectors}>
			{quoteInfo.symbol && (
				<Typography variant='inherit' component='h3' style={styles.companyText}>
					{/* {companyName && !isMobile ? companyName.substring(0, 12) : ''}{' '} */}
					{checkDate
						? !isMobile
							? `${quoteInfo.symbol}`
							: `${quoteInfo.symbol} $${(quoteInfo.latestPrice * 1).toFixed(2)}
     }`
						: quoteInfo.symbol}
				</Typography>
			)}
			{!quoteInfo.symbol && (
				<Typography
					variant='inherit'
					component='h3'
					style={styles.noTickerText}
				>
					Enter a stock ticker to your left & click 'Go'
				</Typography>
			)}
			{quoteInfo.symbol && (
				<div style={styles.stockPriceInfo}>
					{!isMobile && (
						<span
							style={isMobile ? styles.stockPriceMobile : styles.stockPrice}
						>
							 ${(quoteInfo.latestPrice * 1).toFixed(2)}
						</span>
					)}

					<span
						style={
							quoteInfo.change < 0
								? styles.negPriceChange
								: styles.posPriceChange
						}
					>
						{quoteInfo.change < 0 ? (
							<DownArrow
								style={isMobile ? styles.downArrowMobile : styles.downArrow}
							/>
						) : (
							<UpArrow
								style={isMobile ? styles.upArrowMobile : styles.upArrow}
							/>
						)}{' '}
						<span style={styles.priceChange}>
						${Math.abs(quoteInfo.change).toFixed(2)}
						</span>
						({Math.abs(quoteInfo.changePercent).toFixed(2)}
						%)
					</span>

					{refreshingQuote ? (
						<CircularProgress
							style={styles.circularSpinner}
							size={24}
							color='primary'
						/>
					) : (
						<IconButton
							aria-label='Refresh'
							disabled={refreshingQuote}
							size='small'
							color='primary'
							style={styles.refreshButton}
							onClick={() => {
								refreshDataAndExpirationsFunc(
									ticker,
									selectedDate,
									appReducer,
									setAppState
								);
							}}
						>
							<Refresh />
						</IconButton>
					)}
				</div>
			)}
			{quoteInfo.symbol && (
				<div style={{ display: 'flex' }}>
					<Typography
						variant='body1'
						component='div'
						style={{
							...styles.timestampText,
							paddingTop: '2px',
						}}
					>
						As of
						{moment(selectedDate).isBefore(newDate) ? (
							<span style={{ marginLeft: '2px' }}>
								{moment(selectedDate).format('MMM DD')} 4:00pm{' '}
							</span>
						) : (
							<span style={{ marginLeft: '2px' }}>
								{moment(quoteInfo.latestUpdate).format('MMM DD h:mma')}
							</span>
						)}
					</Typography>
					{lengthCheck && (
						<div>
							<div
								style={{
									height: '20px',
									width: '20px',
									marginLeft: '10px',
								}}
								onClick={() =>
									dispatch(setOptionChainAction({ holderModal: true }))
								}
							>
								<img height='100%' width='100%' src={SharkIcon} alt='' />
							</div>
						</div>
					)}
				</div>
			)}
		</Card>
	);
};

export default TickerStats;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/TickerStats.jsx